import './shannondell3/style';
import FormStructure from './shannondell3/form_structure';

export default FormStructure;